export const apiUrl = "https://iter-dev.dev";
export const aiApiUrl = "https://iter-dev.dev/ai";
export const socketPath = "/socket.io";
export const s3Url = "https://iterai-bucket.s3.us-west-2.amazonaws.com";

export const imageUrl = (url) => {
  const result = url?.indexOf("http");
  const imageRenderUrl = result == -1 ? `${s3Url}/${url}` : url;
  return imageRenderUrl;
};
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
export const recordsLimit = 10;
